(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('PatientDetailController', PatientDetailController);

    PatientDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Patient', 'User', 'SurveyResult'];

    function PatientDetailController($scope, $rootScope, $stateParams, entity, Patient, User, SurveyResult) {
        var vm = this;
        vm.patient = entity;
        vm.load = function (id) {
            Patient.get({id: id}, function(result) {
                vm.patient = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:patientUpdate', function(event, result) {
            vm.patient = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
